import { IManagableObject } from 'app/system/admin-panel/IManagableObject';
export class ReportTemplateColumnViewModel implements IManagableObject {
  Id: number;
  IsChecked: boolean;
  Type: number = 0;
  Value: string;
  Name: string;

  init(data?: any) {
    if (data) {
      this.Type = data["type"];
      this.Value = data["value"];
      this.Name = data["name"];
    }
  }

  static fromJS(data: any): ReportTemplateColumnViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ReportTemplateColumnViewModel();
    result.init(data);
    return result;
  }
}
